// extracted by mini-css-extract-plugin
export var cardList = "CardList-module--cardList--aaf3e";
export var cardList_noResults = "CardList-module--cardList_noResults--134c3";